import { CommerceModel } from 'api-types';
import { relewiseTracker } from '../relewiseTracker';
import { useRelewiseQueue } from './useRelewiseQueue';

export const useTrackCartUpdate = () => {
  const { addToQueue } = useRelewiseQueue();

  const trackCartUpdate = (basket: CommerceModel.Basket) => {
    if (!basket || !basket.lines) {
      return;
    }

    const lineItems = basket.lines.map((line) => ({
      productId: line.productId || '',
      variant: line.id || line.productId || '',
      quantity: line.quantity || 0,
      lineTotal: line.priceOutput?.totalPrice?.taxedPrice || line.priceOutput?.totalPrice?.rawValue || 0,
    }));

    addToQueue(({ user }) => {
      if (relewiseTracker) {
        relewiseTracker.trackCart({
          user,
          subtotal: {
            currency: basket.currency || 'DKK',
            amount: basket.totalPrice?.taxedPrice || basket.totalPrice?.rawValue || 0,
          },
          lineItems,
        });
      }
    });
  };

  return { trackCartUpdate };
};